module.exports = __webpack_public_path__ + "img/lens-160-minus-08.bec6a5bc.png";